export function checkProviderWidth () {
  const provider = document.getElementById('provider_info_js')
  if (!provider) return
  if( (window.innerWidth - 1150) < provider.clientWidth) {
    provider.classList.add('provider-info--disabled')
  }
}